import { useCapacitor } from "@/hooks/useCapacitor";

import Navbar from "./Navbar";

const Panel = ({
    children,
    title,
    containerStyles,
    bottomContent,
    className,
}: {
    children: React.ReactNode;
    title?: React.ReactNode;
    containerStyles?: string;
    bottomContent?: React.ReactNode;
    className?: string;
}) => {
    const { isCordova } = useCapacitor();
    return (
        <div className={`flex flex-col h-full  ${className}`}>
            {isCordova && <div className="h-14" />}

            <div className="flex flex-col w-full header">
                <Navbar />
                {title}
            </div>

            <div className="flex flex-col w-full">{bottomContent}</div>

            {containerStyles}
            <div
                className={`${containerStyles} overflow-hidden container-wrapper rounded-[2rem] md:rounded-none md:pt-0 md:pb-0 md:mb-0 col-span-1 md:col-span-7 lg:col-span-8 xl:col-span-11 h-full text-slate-600 flex flex-col`}
            >
                <div className="p-4 pb-2 pt-0  md:px-8 h-full w-full  overflow-auto container-wrap ">{children}</div>
            </div>
        </div>
    );
};

export default Panel;
